import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from '../../api';
const Navbar = ({ toggleSidebar }) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

 
  return (
    <div>
      <header id="header" className="header fixed-top d-flex align-items-center">
        <div className="d-flex align-items-center justify-content-between">
          <Link to="/dashboard" className="logo d-flex align-items-center">
            <img src="https://ik.imagekit.io/realdo/saibranding/svgs/logo-svg.svg" className="h-12" alt="" />
          </Link>
          <i
            className="bi bi-list toggle-sidebar-btn hidden-desktop"
            id="toggle-sidebar-btn"
            onClick={toggleSidebar}
          ></i>
        </div>

        <div className="Quick Action"></div>

      
      </header>
    </div>
  );
};

export default Navbar;
